var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 19.5,
    fill: "#95A5B7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 17.3333C24.7276 17.3333 25.745 17.7547 26.4952 18.5048C27.2453 19.255 27.6667 20.2724 27.6667 21.3333V25.9999H25.0001V21.3333C25.0001 20.9796 24.8596 20.6405 24.6096 20.3904C24.3595 20.1404 24.0204 19.9999 23.6667 19.9999C23.3131 19.9999 22.974 20.1404 22.7239 20.3904C22.4739 20.6405 22.3334 20.9796 22.3334 21.3333V25.9999H19.6667V21.3333C19.6667 20.2724 20.0882 19.255 20.8383 18.5048C21.5885 17.7547 22.6059 17.3333 23.6667 17.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 18H14.3333V26H16.9999V18Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6666 15.9999C16.403 15.9999 16.9999 15.403 16.9999 14.6666C16.9999 13.9302 16.403 13.3333 15.6666 13.3333C14.9302 13.3333 14.3333 13.9302 14.3333 14.6666C14.3333 15.403 14.9302 15.9999 15.6666 15.9999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b9a16242d822e19c17bc10f8589b76d6.svg";
export { ForwardRef as ReactComponent };